export const PRICE_COUNT = 'App/Summary::PRICE_COUNT';
export const CHANGE_START_DATE = 'App/Summary::CHANGE_START_DATE';
